export function conversationUnassignedShopNoticeKind(input: {
  conversationShopBindingId?: string | null;
  seedDisplayName?: string;
}): "hidden" | "create" | "choose_seed" {
  if (input.conversationShopBindingId?.trim()) return "hidden";
  if (!input.seedDisplayName?.trim()) return "choose_seed";
  return "create";
}
